import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { Picture } from 'ui-kit/picture'
import { LINKS } from 'routes/constants'
import DifferenceMobImage1x from './difference-mob@1x.avif'
import DifferenceMobImage2x from './difference-mob@2x.avif'
import DifferenceDeskImage1x from './difference-desk@1x.avif'
import DifferenceDeskImage2x from './difference-desk@2x.avif'
import classes from './LandingDifference.module.scss'

export const LandingDifference = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.wrapper}>
        <Heading as={'h2'} size={'xl'} balance center className={classes.title}>
          There was no good solution for product integrations. <br />
          Until now.
        </Heading>
      </div>

      <Picture
        mobSrc1x={DifferenceMobImage1x.src}
        mobSrc2x={DifferenceMobImage2x.src}
        deskSrc1x={DifferenceDeskImage1x.src}
        deskSrc2x={DifferenceDeskImage2x.src}
        className={classes.image}
        alt='Good solution for product integrations'
        lazyLoad
      />

      <Text size={'lg'} center className={classes.subtitle}>
        We took the best from the previous generations of integration products
        and added so much more
      </Text>

      <Link
        className={classes.link}
        type='secondary'
        href={LINKS.HOW_WE_ARE_DIFFERENT}
      >
        See how we differ from Unified APIs and Embedded iPaaS
      </Link>
    </Block>
  )
}
